import { useProcessOperationMutation } from 'generated/graphql';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSearchParam } from 'react-use';
import { useGetUser } from 'v2/core/services/user';
import { useNotificationContext } from '../components/Notification/NotificationContext';
import { NOTIFICATION_TIMEOUT_LONG_6S } from '../constants';

const PROCESS_OPERATION_TOKEN_PARAM = 'operationToken';

export const useProcessOperationFromURLParams = () => {
  const operationToken = useSearchParam(PROCESS_OPERATION_TOKEN_PARAM);

  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const onError = (error?: Error) => {
    if (!error) {
      return;
    }
    showErrorNotification({
      contentComponent: 'Failed to process operation, please refresh the page',
      props: {
        timeout: NOTIFICATION_TIMEOUT_LONG_6S,
      },
    });
  };

  const navigate = useNavigate();
  const location = useLocation();

  const onCompleted = () => {
    const params = new URLSearchParams(location.search);
    params.delete(PROCESS_OPERATION_TOKEN_PARAM);
    const paramsStr =
      params.toString().length > 0 ? `?${params.toString()}` : '';
    navigate(`${location.pathname}${paramsStr}`, { replace: true });
  };

  const [processOperation] = useProcessOperationMutation({
    variables: {
      request: {
        userID,
        tenantID,
        operationToken: operationToken ?? '',
      },
    },
    onCompleted,
    onError,
  });

  useEffect(() => {
    if (!operationToken) {
      return;
    }
    processOperation();
  }, [operationToken, processOperation]);
};
